import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SIZE } from '../../../constants/size'
import { useDateLocale } from '../../../hooks'
import { ConfirmationModal } from '../../Confirmation'

import { QA_NAME_CALENDAR_FOLLOW_UP_CAP_MODAL } from './CalendarFollowUpCapModal.constants'
import { getCalendarFollowUpCapDescription } from './CalendarFollowUpCapModal.utils'
import { NextFreeDayButton } from './NextFreeDayButton'

function CalendarFollowUpCapModal({ dayLoad, item, onClose, onMove }) {
  const { t } = useTranslation()

  const locale = useDateLocale()

  const [isMoving, setMoving] = useState(false)

  async function handleMove(date) {
    setMoving(true)

    return onMove({ date, item }).finally(() => {
      setMoving(false)
    })
  }

  async function handleSubmit() {
    return handleMove(dayLoad.date)
  }

  function handleMoveToNextFreeDate() {
    handleMove(dayLoad.next_free_date)
  }

  return (
    <ConfirmationModal
      actionButtonsProps={{
        children: (
          <NextFreeDayButton
            date={dayLoad.next_free_date}
            isLoading={isMoving}
            onClick={handleMoveToNextFreeDate}
          />
        ),
        submitText: t('Calendar.CapProceedKey'),
      }}
      boxSize={SIZE.LARGE}
      description={getCalendarFollowUpCapDescription({ dayLoad, locale, t })}
      loading={isMoving}
      qaName={QA_NAME_CALENDAR_FOLLOW_UP_CAP_MODAL}
      onCancel={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default CalendarFollowUpCapModal
